export default __webpack_public_path__ + "static/Plots0002-b65e067d6a9cb15f9b6ff69ec9ff6b9a.jpg";